import {Table} from './table.js';

export class MarkdownTable {
  constructor(headers, rows) {
    this.table = new Table(headers, rows);
  }

  markdown() {
    const rows = [
      this.table.headers(),
      this.table.separators(),
      ...this.table.cellRows()
    ];

    return rows.map(cells => '| ' + cells.join(' | ') + ' |').join("\n") + '\n';
  }

  firstCellSelected() {
    return {
      offset: this.rowAndNewlineWidth() * 2 + 2,
      length: this.table.firstCell().length
    };
  }

  rowAndNewlineWidth() {
    return this.rowWidth() + 1;
  }

  rowWidth() {
    return this.table.columnsWidths().map(width => 3 + width).reduce(sum, 1);
  }
}

function sum(a, b) {
  return a + b;
}
